import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PageSeo from "components/Seo/PageSeo";
import PageHero from "components/PageHero/PageHero";
import "components/Home/homeShared.css";
import "components/Home/ProgramGrid/ProgramGrid.css";
import "./programsPage.css";

const ProgramsIndex = () => {
  const programs = useSelector(
    (state) => state.contentfulReducer.programTitles
  );

  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <>
      <PageSeo
        title="Gymnastics Programs"
        description="Browse Ace Gymnastics programs in Bardstown, KY — preschool, recreational, competitive, and private lessons for ages 18 months to 18 years."
        path="/programs/program-details/"
      />
      <PageHero
        title="Programs"
        subtitle="Find the right class for your athlete — browse schedules, tuition, and register or join a waitlist online."
        imageAlt="Ace Gymnastics programs"
      />
      <section className="home-section programs-page__index" aria-label="All programs">
        <div className="home-section__inner">
          <div className="home-program-grid">
            {programs.map((program) => {
              const fields = program.fields;
              const imageUrl = fields.image?.fields?.file?.url;
              const path = `/programs/program-details/${fields.displayName}`;

              return (
                <article key={fields.displayName} className="home-program-card">
                  <Link
                    to={path}
                    onClick={scrollToTop}
                    className="home-program-card__link"
                    data-track="program_click"
                    data-track-location="programs_index"
                    data-track-item={fields.displayName}
                  >
                    {imageUrl && (
                      <div className="home-program-card__image-wrap">
                        <img
                          src={imageUrl}
                          alt={`${fields.name || fields.displayName} gymnastics program at Ace Gymnastics`}
                          width="400"
                          height="300"
                          loading="lazy"
                        />
                      </div>
                    )}
                    <div className="home-program-card__body">
                      <h2 className="home-program-card__title">
                        {fields.name || fields.displayName}
                      </h2>
                      {fields.description && (
                        <p className="home-program-card__desc">
                          {fields.description.length > 120
                            ? `${fields.description.slice(0, 120).trim()}…`
                            : fields.description}
                        </p>
                      )}
                      <span className="home-program-card__cta">
                        View classes →
                      </span>
                    </div>
                  </Link>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgramsIndex;
